<template>
    <v-container fluid px-3 pt-3>
        <v-row row wrap>
            <v-col cols="12">
                <h3>Certificate Order Details</h3>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <h4>Message Details</h4>
            </v-col>
            <v-col cols="4">
                <b>Received: </b> {{ mail.sentDate }}
            </v-col>
            <v-col cols="4">
                <b>Certificate Type: </b> {{ modToString(mail.modType) }}
            </v-col>
            <v-col cols="4">
                <b>Certificate Order(#): </b> {{ mail.subMessage }}
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
            <v-col cols="12">
                <b>Message: </b>
                <div style="white-space: pre-line">{{ mail.message }}</div>
            </v-col>
            <v-col cols="6">
                <v-btn v-if="mail.requestId" @click="acknowledge(mail.requestId, mail.modType)" color="secondary" :disabled="isLoading">Take Me To The Order</v-btn>
                <v-btn v-if="!mail.requestId" @click="acknowledge(mail.requestId, mail.modType)" color="secondary" :disabled="isLoading">Reorder</v-btn>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
            <v-col cols="12" v-if="mail.messageType == 10">
                <b style="color:red;font-size:medium;">This order has been removed from your inbox</b>
            </v-col>
            <v-col cols="12" v-if="mail.requestId">
                <h4>Order Details</h4>
            </v-col>
        </v-row>
        <v-row v-if="mail.modType == 10 && mail.requestId">
            <v-col cols="12">
                <h5>Birth Certificate Request Information</h5>
            </v-col>
            <v-col cols="6">
                <b>Name: </b> {{ birth.certFirstName + " " + birth.certMiddleName + " " + birth.certLastName }}
            </v-col>
            <v-col cols="3">
                <b>Certificates(#): </b> {{ birth.numCerts }}
            </v-col>
            <v-col cols="3">
                <b>Affidavits(#): </b> {{ birth.numAffidavits }}
            </v-col>
            <v-col cols="6">
                <b>Other Names: </b> {{ birth.certOtherNames }}
            </v-col>
            <v-col cols="6">
                <b>Date of Birth: </b> {{ birth.certDob }}
            </v-col>
            <v-col cols="6">
                <b>Place of Birth (City): </b> {{ birth.certCity }}
            </v-col>
            <v-col cols="6">
                <b>Place of Birth (County): </b> {{ birth.certCounty }}
            </v-col>
            <v-col cols="6">
                <b>Mother's Name: </b> {{ birth.certMotherFirstName + " " + birth.certMotherMiddleName + " " + birth.certMotherLastName }} <b>Maiden: </b> {{ birth.certMotherMaidenName }}
            </v-col>
            <v-col cols="6">
                <b>Other Parent's Name: </b> {{ birth.certOtherFirstName + " " + birth.certOtherMiddleName + " " + birth.certOtherLastName }} <b>Maiden: </b> {{ birth.certOtherMaidenName }}
            </v-col>
            <v-col cols="12">
                <h5>Requestor's Information</h5>
            </v-col>
            <v-col cols="6">
                <b>Name: </b> {{ birth.reqFirstName + " " + birth.reqMiddleName + " " + birth.reqLastName }}
            </v-col>
            <v-col cols="6">
                <b>Mailing Address: </b> {{ birth.mailingAddress.formAddress + " " + birth.mailingAddress.formAddress2 + " " +
                    birth.mailingAddress.city + ", " + birth.mailingAddress.state + ", " + birth.mailingAddress.country }}
            </v-col>
            <v-col cols="6">
                <b>Phone(#): </b> {{ birth.phone }}
            </v-col>
            <v-col cols="6">
                <b>Email: </b> {{ birth.email }}
            </v-col>
            <v-col cols="6">
                <b>Relationship: </b> {{ birth.relationship }}
            </v-col>
            <v-col cols="6">
                <b>Purpose: </b> {{ birth.purpose }}
            </v-col>
            <v-col cols="6">
                <b>Signature: </b> {{ birth.signature }}
            </v-col>
            <v-col cols="6">
                <b>Signed Date: </b> {{ birth.date }}
            </v-col>
        </v-row>
        <v-row v-if="mail.modType == 40 && mail.requestId">
            <v-col cols="12">
                <h5>Death Certificate Request Information</h5>
            </v-col>
            <v-col cols="6">
                <b>Name: </b> {{ death.certFirstName + " " + death.certMiddleName + " " + death.certLastName }}
            </v-col>
            <v-col cols="6">
                <b>Certificates(#): </b> {{ death.numCerts }}
            </v-col>
            <v-col cols="6">
                <b>Other Names: </b> {{ death.certOtherNames }}
            </v-col>
            <v-col cols="6">
                <b>Death Date: </b> {{ death.certDeathDate }}
            </v-col>
            <v-col cols="6">
                <b>Place of Death(City): </b> {{ death.certDeathCity }}
            </v-col>
            <v-col cols="6">
                <b>Place of Death(County): </b> {{ death.certDeathCounty }}
            </v-col>
            <v-col cols="12">
                <h5>Requestor's Information</h5>
            </v-col>
            <v-col cols="6">
                <b>Name: </b> {{ death.reqFirstName + " " + death.reqMiddleName + " " + death.reqLastName }}
            </v-col>
            <v-col cols="6">
                <b>Mailing Address: </b> {{ death.mailingAddress.formAddress + " " + death.mailingAddress.formAddress2 + " " +
                    death.mailingAddress.city + ", " + death.mailingAddress.state + ", " + death.mailingAddress.country }}
            </v-col>
            <v-col cols="6">
                <b>Phone(#): </b> {{ death.phone }}
            </v-col>
            <v-col cols="6">
                <b>Email: </b> {{ death.email }}
            </v-col>
            <v-col cols="6">
                <b>Relationship: </b> {{ death.relationship }}
            </v-col>
            <v-col cols="6">
                <b>Purpose: </b> {{ death.purpose }}
            </v-col>
            <v-col cols="6">
                <b>Signature: </b> {{ death.signature }}
            </v-col>
            <v-col cols="6">
                <b>Signed Date: </b> {{ death.date }}
            </v-col>
        </v-row>
        <v-row v-if="mail.modType == 20 && mail.requestId">
            <v-col cols="12">
                <h5>Marriage Certificate Request Information</h5>
            </v-col>
            <v-col cols="5">
                <b>Name 1: </b> {{ marriage.firstName1 + " " + marriage.middleName1 + " " + marriage.lastName1 }}
            </v-col>
            <v-col cols="5">
                <b>Name 2: </b> {{ marriage.firstName2 + " " + marriage.middleName2 + " " + marriage.lastName2 }}
            </v-col>
            <v-col cols="2">
                <b>Certificates(#): </b> {{ marriage.numCerts }}
            </v-col>
            <v-col cols="12">
                <h5>Requestor's Information</h5>
            </v-col>
            <v-col cols="6">
                <b>Name: </b> {{ marriage.reqFirstName + " " + marriage.reqMiddleName + " " + marriage.reqLastName }}
            </v-col>
            <v-col cols="6">
                <b>Mailing Address: </b> {{ marriage.mailingAddress.formAddress + " " + marriage.mailingAddress.formAddress2 + " " +
                    marriage.mailingAddress.city + ", " + marriage.mailingAddress.state + ", " + marriage.mailingAddress.country }}
            </v-col>
            <v-col cols="6">
                <b>Phone(#): </b> {{ marriage.phone }}
            </v-col>
            <v-col cols="6">
                <b>Email: </b> {{ marriage.email }}
            </v-col>
            <v-col cols="6">
                <b>Relationship: </b> {{ marriage.relationship }}
            </v-col>
            <v-col cols="6">
                <b>Purpose: </b> {{ marriage.purpose }}
            </v-col>
            <v-col cols="6">
                <b>Signature: </b> {{ marriage.signature }}
            </v-col>
            <v-col cols="6">
                <b>Signed Date: </b> {{ marriage.date }}
            </v-col>
        </v-row>
        <v-row v-if="mail.modType == 30 && mail.requestId">
            <v-col cols="12">
                <h5>Divorce Certificate Request Information</h5>
            </v-col>
            <v-col cols="5">
                <b>Name 1: </b> {{ divorce.firstName1 + " " + divorce.middleName1 + " " + divorce.lastName1 }}
            </v-col>
            <v-col cols="5">
                <b>Name 2: </b> {{ divorce.firstName2 + " " + divorce.middleName2 + " " + divorce.lastName2 }}
            </v-col>
            <v-col cols="2">
                <b>Certificates(#): </b> {{ divorce.numCerts }}
            </v-col>
            <v-col cols="12">
                <h5>Requestor's Information</h5>
            </v-col>
            <v-col cols="6">
                <b>Name: </b> {{ divorce.reqFirstName + " " + divorce.reqMiddleName + " " + divorce.reqLastName }}
            </v-col>
            <v-col cols="6">
                <b>Mailing Address: </b> {{ divorce.mailingAddress.formAddress + " " + divorce.mailingAddress.formAddress2 + " " +
                    divorce.mailingAddress.city + ", " + divorce.mailingAddress.state + ", " + divorce.mailingAddress.country }}
            </v-col>
            <v-col cols="6">
                <b>Phone(#): </b> {{ divorce.phone }}
            </v-col>
            <v-col cols="6">
                <b>Email: </b> {{ divorce.email }}
            </v-col>
            <v-col cols="6">
                <b>Relationship: </b> {{ divorce.relationship }}
            </v-col>
            <v-col cols="6">
                <b>Purpose: </b> {{ divorce.purpose }}
            </v-col>
            <v-col cols="6">
                <b>Signature: </b> {{ divorce.signature }}
            </v-col>
            <v-col cols="6">
                <b>Signed Date: </b> {{ divorce.date }}
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import mailService from '@/services/mailService'
import certificateService from '@/services/certificateService'
export default {
    data: () => {
        return {
            mail: {},
            birth: {},
            death: {},
            marriage: {},
            divorce: {},
            isLoading: false
        }
    },
    mounted: function () {
        mailService.getMailById(this.$http, this.$route.params.id).then(response => {
            this.mail = response.data.mail[0]
            this.setUpPage()
        })
    },
    methods: {
        setUpPage () {
            if (this.mail == null) {
                return
            }

            switch (this.mail.modType) {
            case 10: {
                certificateService.getBirthOrderById(this.$http, this.mail.subMessage).then(response => {
                    this.birth = response.data
                })
                break
            }
            case 40: {
                certificateService.getDeathOrderById(this.$http, this.mail.subMessage).then(response => {
                    this.death = response.data
                })
                break
            }
            case 20: {
                certificateService.getMarriageDivorceOrderById(this.$http, this.mail.subMessage, '20').then(response => {
                    this.marriage = response.data
                })
                break
            }
            case 30: {
                certificateService.getMarriageDivorceOrderById(this.$http, this.mail.subMessage, '30').then(response => {
                    this.divorce = response.data
                })
                break
            }
            }
        },
        modToString (modType) {
            switch (modType) {
            case '10':
            case 10: return 'Birth'
            case '20':
            case 20: return 'Marriage'
            case '30':
            case 30: return 'Divorce'
            case '40':
            case 40: return 'Death'
            default: return modType
            }
        },
        acknowledge (requestId, modType) {
            this.isLoading = true
            mailService.acknowledgeMail(this.$http, this.$route.params.id).then(response => {
                this.isLoading = false
                var redirectString = '/order-'
                switch (modType) {
                case '10':
                case 10:
                    redirectString += 'birth-certificate'
                    break
                case '20':
                case 20:
                    redirectString += 'marriage-certificate'
                    break
                case '30':
                case 30:
                    redirectString += 'divorce-certificate'
                    break
                case '40':
                case 40:
                    redirectString += 'death-certificate'
                    break
                }
                if (requestId) {
                    this.$router.push(redirectString + '?orderId=' + requestId)
                    return
                }
                this.$router.push(redirectString)
            })
        }
    }
}
</script>
